import React from 'react';
import { VIP_URL } from '@constants';
import Modal from '@components/Modal';
import Button from '@components/Button';
import Title from '@components/Title';
import { useMaxSceneNumber } from '@utils/getMaxSceneNumber';

interface Props {
  onRequestClose: () => void;
}

function NoSpaceModal({ onRequestClose }: Props) {
  const { level } = useMaxSceneNumber();
  const withExpand = level >= 1;
  const footer = (
    <>
      <Button as="a" href={VIP_URL} target="_blank">
        升级会员
      </Button>
      {!!withExpand && (
        <Button className="ml-10" as="a" href="/buy/6" target="_blank">
          单独扩容
        </Button>
      )}
    </>
  );
  return (
    <Modal
      isOpen
      onRequestClose={onRequestClose}
      header={<Title>空间容量不足</Title>}
      footer={footer}
    >
      <div className="flex h-full flex-col items-center justify-center">
        <div className="mb-10 text-lg">当前空间容量不足</div>
        {withExpand ? (
          <>
            <div>
              建议清理不必要素材，压缩体积/大小，或者升级会员/空间扩容后再上传
            </div>
            <div className="mt-10 text-justify font-bold">
              <span style={{ color: '#ff0000' }}>特别提醒：</span>
              <span>
                空间扩容服务只扩充素材库空间容量，不能提升作品场景数量
              </span>
            </div>
          </>
        ) : (
          <div>建议清理不必要素材，压缩体积/大小，或者升级会员后再上传</div>
        )}
      </div>
    </Modal>
  );
}

export default NoSpaceModal;
